export default __webpack_public_path__ + "svg/calendar/2026/6/octubre.svg?4c1abf1f";